




































import Vue from "vue";
import ContEven from "@/models/continuity/ContEven";
import { MARCH_TYPES } from "@/models/util/constants";
import StuntSheet from "@/models/StuntSheet";
import { Mutations } from "@/store/mutations";

/**
 * View/Edit an In Place continuity
 */
export default Vue.extend({
  name: "ContEvenEditor",
  props: {
    continuityIndex: {
      type: Number,
      required: true,
    },
    dotTypeIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    marchTypeOptions() {
      // HS and MM should have a "MT" prefix
      return [
        {
          friendlyName: "EVEN MARCH MM",
          value: MARCH_TYPES.MINI_MILITARY,
        },
        {
          friendlyName: "EVEN MARCH HS",
          value: MARCH_TYPES.HS,
        },
      ];
    },
    selectedMarchType: {
      get(): MARCH_TYPES {
        const continuity: ContEven = this.$store.getters.getContinuity(
          this.dotTypeIndex,
          this.continuityIndex
        );
        return continuity.marchType;
      },
      set(marchType: MARCH_TYPES): void {
        this.$store.commit(Mutations.UPDATE_DOT_TYPE_MARCH_STYLE, {
          dotTypeIndex: this.dotTypeIndex,
          continuityIndex: this.continuityIndex,
          marchType: marchType,
        });
      },
    },
    selectedDuration: {
      get(): number {
        const continuity: ContEven = this.$store.getters.getContinuity(
          this.dotTypeIndex,
          this.continuityIndex
        );
        return continuity.duration;
      },
      set(duration: number): void {
        this.$store.commit(Mutations.UPDATE_DOT_TYPE_DURATION, {
          dotTypeIndex: this.dotTypeIndex,
          continuityIndex: this.continuityIndex,
          duration: duration,
        });
      },
    },
    canDelete(): boolean {
      const selectedSS = this.$store.getters
        .getSelectedStuntSheet as StuntSheet;
      return selectedSS.dotTypes[this.dotTypeIndex].length > 1;
    },
  },
  methods: {
    deleteContinuity() {
      this.$store.commit(Mutations.DELETE_DOT_TYPE_CONTINUITY, {
        dotTypeIndex: this.dotTypeIndex,
        continuityIndex: this.continuityIndex,
      });
    },
  },
});
